<h1 class="sp-subheader__title-page pb-1 title">Mi Perfil</h1>
<div class="card card__title profile">
    <nav class="toolbar toolbar-icon align-content-center">
        <div class="rounded-pill d-flex align-items-center">
          <a type="button" class="btn btn-hover" routerLink="/dashboard">
            <i class="me-1 sidebar-text fa-solid fa-arrow-left"></i>
            <span class="types-custom__letter">Atrás</span>
          </a>
          <!-- <button class="btn btn-hover" type="submit" form="miPerfilForm">
            <i class=" me-1 sidebar-text fa-solid fa-floppy-disk"></i>
            <span class="types-custom__letter">Guardar</span>
          </button> -->
        </div>
    </nav>
    <div class="profile-content scroll">
        <div class="row">
            <div class="col-12 col-lg-7 col-xl-8 mb-3">
                <form [formGroup]="miPerfilForm" id="miPerfilForm" (ngSubmit)="submit()">
                    <div class="row m-0">
                        <div class="col-sm-3 mb-2 d-flex justify-content-center">
                            <div class="profile-content-img" >
                                <img [class]="classes.cropResult"  src="data:image/jpeg;base64,{{photouser }}" (click)="popupVisible=true" alt="imagen recortada usada como principal"> 
                                <i class="fa-solid fa-camera"></i>                                
                            </div>                            
                        </div>
                        <div class="col-sm-9">
                            <h3 class="card-userinfo-name subtitle">{{sessionData.displayName}}</h3>
                            <h3 class="card-userinfo subtitle">{{sessionData.roleCode}}</h3>
                            <h3 class="card-userinfo subtitle">{{sessionData.companyName}}</h3>
                            <!-- <h3 class="card-userinfo subtitle"><strong>Último ingreso:</strong>  {{fechaIngreso | date: 'short'}}</h3> -->
                        </div>
                    </div>
                    <div class="mt-3">
                        <ul class="list-group list-group-horizontal row text-center title_options mx-0">
                            <li class="list-group-item col-6 border-0 active" id="usuar_dataBtn" (click)="active(origen = 'usuar_dataBtn')">
                                <span class="subtitle">Datos de usuario</span>
                            </li>
                            <!-- <li class="list-group-item col-6 border-0" id="preference_Site" (click)="active(origen = 'preference_Site')">
                                <span class="subtitle">Preferencias del sitio</span>
                            </li> -->
                        </ul>
                    </div>
                    <div>
                        <div formGroupName="datosUser" class="mt-3">
                                <!-- Rounded switch -->
                                <div class="row m-0" *ngIf="!showForm2">
                                    <!-- <div class="col-lg-6">
                                        <label for="tip_nomb" class="d-block labelClass text">Nombre a mostrar en el portal</label>
                                        <div class="d-flex">
                                            <label for="tip_nomb" class="labelClass text">Nombre Real </label>
                                            <label class="switch positionCheckbox">
                                                <input type="checkbox" id="tip_nomb" class="form-control" formControlName="tip_nomb" (change)="changeName()">
                                                <span class="slider round"></span>
                                            </label>
                                            <label for="tip_nomb" class="labelClass text">Nombre de usuario </label>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <label for="nom_usua" class="d-block labelClass text">Nombre de usuario</label>
                                        <input name="nom_usua" class="form-control text" formControlName="nom_usua" type="name">
                                    </div>
                                     <div class="col-sm-6">
                                        <label for="password" class="d-block labelClass">Contraseña</label>
                                        <input name="password" class="form-control"  formControlName="password" type="password">
                                    </div> 
                                    <div class="col-lg-6 mt-auto">
                                        <button type="button" class="btn-principal m-auto d-flex justify-content-center text" (click)="changeModal()">Cambiar contraseña</button>
                                    </div> -->
                                </div>
                        </div>
                    </div>
                    <div>
                        <div formGroupName="datosUser">
                                <!-- Rounded switch -->
                                <div class="row m-0" *ngIf="showForm2">
                                    <div class="col-lg-6">
                                        <label class="d-block labelClass text">Idioma</label>
                                        <div>
                                            <input type="radio" id="Es" value="Es" name="cod_lang" class="form-control"  formControlName="cod_lang">
                                            <label for="Es" class="mr-4 text"><img class="lang mr-2" src="assets/img/lang-es.png" alt="">Español (ES)</label>
                                            <input type="radio" id="En" value="En" name="cod_lang" class="form-control"  formControlName="cod_lang">
                                            <label for="En" class="text"><img class="lang mr-2" src="assets/img/lang-en.png" alt="">Ingles (EN)</label>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <label class="d-block labelClass text">Ordenar empresas por</label>
                                        <div>
                                            <input type="radio" id="name" value="N" name="ord_empc" class="form-control"  formControlName="ord_empc">
                                            <label for="name" class="labelClass mr-4 text">Nombre</label>
                                            <input type="radio" id="cod" value="C" name="ord_empc" class="form-control"  formControlName="ord_empc">
                                            <label for="cod" class="labelClass text">Código</label>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <label class="d-block labelClass text">Habilitar notificaciones</label>
                                        <div class="row m-0">
                                            <div class="col-sm-12 d-flex justify-content-between">
                                                <div class="">
                                                    <label for="env_cumc" class="labelClass text">Cumpleaños</label>
                                                </div>
                                                <div class="d-flex align-items-center flex-nowrap">
                                                    <label for="env_cumc" class="float-right labelClass text m-0">No</label>
                                                    <label class="switch float-right positionCheckbox">
                                                        <input type="checkbox" id="env_cumc" class="form-control" formControlName="env_cumc">
                                                        <span class="slider round"></span>
                                                    </label>
                                                    <label for="env_cumc" class="float-right labelClass text m-0">Si</label>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 d-flex justify-content-between">
                                                <div class="">
                                                    <label for="env_proc" class="labelClass text">Finalización de procesos</label>
                                                </div>
                                                <div class="d-flex align-items-center flex-nowrap">
                                                    <label for="env_proc" class="float-right labelClass text m-0">No</label>
                                                    <label class="switch float-right positionCheckbox">
                                                        <input type="checkbox" id="env_proc" class="form-control" formControlName="env_proc">
                                                        <span class="slider round"></span>
                                                    </label>
                                                    <label for="env_proc" class="float-right labelClass text m-0">Si</label>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 d-flex justify-content-between">
                                                <div class="">
                                                    <label for="env_nota" class="labelClass text">Alertas de notas</label>
                                                </div>
                                                <div class="d-flex align-items-center flex-nowrap">
                                                    <label for="env_nota" class="float-right labelClass text m-0">No</label>
                                                    <label class="switch float-right positionCheckbox">
                                                        <input type="checkbox" id="env_nota" class="form-control" formControlName="env_nota">
                                                        <span class="slider round"></span>
                                                    </label>
                                                    <label for="env_nota" class="float-right labelClass text m-0">Si</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <label class="d-block labelClass text">Personalización de inicio y colores</label>
                                        <div class="d-flex justify-content-center flex-wrap">
                                            <a href="/portal/personalizacion">
                                                <button type="button" class="btn-redirect text"><i class="fa-solid fa-palette"></i> Colores </button>
                                            </a>
                                            <a href="/portal/dashboard">
                                                <button type="button" class="btn-redirect text"><i class="fa-solid fa-house-user"></i> Pantalla de inicio </button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-12 col-lg-5 col-xl-4 mb-3">
                <div class="v-line">
                        <h4 class="title_programs title">Top 5 programas</h4>
                        <div class="div">
                            <h5 class="subTitle_programs title">Más usados</h5>
                            <div class="div">
                                <ol>
                                    <li class="li-topPrograms" *ngFor="let l of listFavorite">
                                        <a (click)="openProgram(l)" [attr.aria-label]="l.codigoPrograma" routerLink="/pageTabPanel"  name="{{l.codigoPrograma}}">
                                        <span class="li-title text">{{l.name || l.nom_prog}}  <i class="fa-solid fa-arrow-up-right-from-square"></i></span>
                                    </a>
                                </li>
                            </ol>
                        </div>
                    </div>
                    <div class="div">
                        <h5 class="subTitle_programs title">Recientes</h5>
                        <div class="div">
                            <ol>
                                <li *ngFor="let l of listHisotrial" class="li-topPrograms">
                                    <a (click)="openProgram(l)" [attr.aria-label]="l.codigoPrograma" routerLink="/pageTabPanel"  name="{{l.codigoPrograma}}">
                                        <span class="li-title text">{{l.name}}  <i class="fa-solid fa-arrow-up-right-from-square"></i></span>
                                    </a>
                                </li>
                               
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <!-- <footer class="d-flex justify-content-center">
        <button type="submit" form="miPerfilForm" class="btn-principal my-2 text">
            Guardar
        </button>
      </footer> -->
</div>


<ng-template #changePassword let-modal>
    <form [formGroup]="passwordForm" (ngSubmit)="changePass()">
        <button class="close modal-close" type="button" aria-label="Close" (click)="modal.dismiss()">
            <i class="fas fa-times"></i>
        </button>
        <h3 class="sp-portlet__form-title prt-mep mt-5 text-center title">Cambiar clave</h3>
        <div class="modal-body text-center modal-lg py-0 ml-5 mr-5">
            <div class="form-group mt-4">
                <div class="form-group">
                    <label for="actual">Clave Anterior:</label>
                    <input formControlName="actual" [type]="showoldPassword ? 'text' : 'password'" id="actual" name="actual" ngModel required class="form-control" placeholder="Ingresa tu contraseña actual">
                    <span (click)="showoldPassword = !showoldPassword" class="form__icon fa-solid" [ngClass]="showoldPassword ? 'fa-eye' : 'fa-eye-slash'"></span>
                    <div *ngIf="passwordForm.get('actual')?.errors?.['required']">Este campo es requerido.</div>
                </div>
                <div class="form-group">
                    <label for="nueva">Nueva Contraseña:</label>
                    <input id="nueva" formControlName="nueva" name="nueva" ngModel [type]="showPassword ? 'text' : 'password'" class="form-control" placeholder="Ingresa tu nueva contraseña"  required/>
                    <span (click)="showPassword = !showPassword" class="form__icon fa-solid" [ngClass]="showPassword ? 'fa-eye' : 'fa-eye-slash'"></span>
                    <div *ngIf="passwordForm.get('nueva')?.errors?.['required']">Este campo es requerido.</div>
                </div>
                <div class="form-group">
                    <label for="confirma">Confirmar Contraseña:</label>
                    <input id="confirma" formControlName="confirma" name="confirma" ngModel [type]="showPassword ? 'text' : 'password'" class="form-control" placeholder="Confirma tu nueva contraseña"  required/>
                    <div *ngIf="passwordForm.get('confirma')?.errors?.['required']">Este campo es requerido.</div>
                </div>
            </div>
        </div>
    <div class="modal-footer justify-content-center">
        <button class="btn btn-secondary" type="button" (click)="modal.dismiss()">Cancelar</button>
        <button class="btn-principal" type="submit">Confirmar</button>
    </div>
</form>
  </ng-template>
<dx-popup
    [maxWidth]="800"
    [minWidth]="500"
    [width]="'60vw'"
    [height]="600"
    [showTitle]="true"
    title=""
    [dragEnabled]="false"
    [showCloseButton]="false"
    container=".dx-viewport"
    [(visible)]="popupVisible"    
  
    >
      <!-- (onShown)="userInfo.fot_usua ? getCropped() : _fileInput.click()" -->
    <button class="btn-close" (click)="popupVisible = false">
        <i class="fa-solid fa-xmark"></i>
    </button>
    <div class="content-popup">
        <div class="content-popup-header mb-3">
            <h3 class="title color-primary">Cambiar foto</h3>
            <p class="text color-primary">Ajusta la imagen al circulo central</p>
            <button class="btn-yellow" (click)="_fileInput.click()">
                <i class="fa-solid fa-upload"></i>
                Cargar nueva foto
            </button>
        </div>
        <!-- Hidden input -->
        <input #_fileInput type="file" (change)="croppers.selectInputEvent($event)" accept="image/*" hidden>
        <ly-img-cropper
        #croppers
        [config]="myConfig"
        [(scale)]="scale"
        (minScale)="minScale = $event"
        (ready)="ready = true"
        (cleaned)="ready = false"
        (cropped)="onCropped($event)"
        (loaded)="onLoaded($event)"
        (error)="onError($event)"
        >
        </ly-img-cropper>
        <div *ngIf="ready" [className]="classes.sliderContainer">
            <button (click)="cropper.zoomOut()"><i class="fa-solid fa-minus"></i></button>
            <ly-slider
            [thumbVisible]="false"
            [min]="minScale"
            [max]="1"
            [(ngModel)]="scale"
            (input)="onSliderInput($event)"
            step="0.000001"></ly-slider>
            <button (click)="cropper.zoomIn()"><i class="fa-solid fa-plus"></i></button>
        </div>  
    </div>
    <div class="d-flex justify-content-between">
        <button class="btn-secondary" (click)="popupVisible = false">Cancelar</button>
        <button class="btn-principal" (click)="cropper.crop();" [disabled]="!imgLoadedTem">Guardar</button>
    </div>
</dx-popup>
